import { CompositeId } from '@capital-access/profiles/common';
import { ReportSectionConfigurationWithOrder } from '@capital-access/reporting/common';

const MIN_ZOOM_PERCENTAGE = 10;
const MAX_ZOOM_PERCENTAGE = 200;
export const SCALE_FACTOR = (MAX_ZOOM_PERCENTAGE - MIN_ZOOM_PERCENTAGE) / (MAX_ZOOM_PERCENTAGE / 50);
export const formatZoomValue = (value: number): number => value * SCALE_FACTOR;

export function isValidKeyInput(event: KeyboardEvent, currentValue: string, maxValue: number): boolean {
  const key = event.key;
  if (key.length > 1) {
    return true;
  }
  const input = event.target as HTMLInputElement;
  const selectionStart = input.selectionStart || 0;
  const selectionEnd = input.selectionEnd || 0;

  const newValue = currentValue.substring(0, selectionStart) + key + currentValue.substring(selectionEnd);
  const newNumber = parseInt(newValue, 10);

  return newNumber < maxValue;
}

export function getUniqueProfileIds(profileIds: CompositeId[]): string[] {
  const uniqueKeys = new Set<string>();

  profileIds.forEach(profileId => {
    const profileIdKey = profileId.hasPrId ? `${profileId.prId}` : profileId.toString();

    if (!uniqueKeys.has(profileIdKey)) {
      uniqueKeys.add(profileIdKey);
    }
  });

  return [...uniqueKeys];
}

export function getReportSectionConfig(
  sections: ReportSectionConfigurationWithOrder[],
  name: string
): ReportSectionConfigurationWithOrder | undefined {
  let reportSectionConfig = sections.find(section => section.config.name === name);

  if (!reportSectionConfig && name) {
    reportSectionConfig = sections.find(section => section.config.nestedItems?.some(nested => nested.name === name));

    if (reportSectionConfig && name) {
      const nestedMatch = reportSectionConfig.config.nestedItems?.find(nested => nested.name === name);
      if (nestedMatch && nestedMatch.nestedItemSectionConfiguration) {
        return nestedMatch.nestedItemSectionConfiguration;
      }
    }
  }
  return reportSectionConfig;
}

export function getModifiedReportSection(
  sections: ReportSectionConfigurationWithOrder[],
  modifiedReportSection: ReportSectionConfigurationWithOrder
): ReportSectionConfigurationWithOrder[] {
  return sections.map(section => {
    if (section.config.name === modifiedReportSection.config.name) {
      return modifiedReportSection;
    } else if (section.config.nestedItems) {
      const updatedNestedItems = section.config.nestedItems.map(nested => {
        if (nested.name === modifiedReportSection.config.name && nested.nestedItemSectionConfiguration) {
          return {
            ...nested,
            nestedItemSectionConfiguration: modifiedReportSection
          };
        }
        return nested;
      });
      return {
        ...section,
        config: {
          ...section.config,
          nestedItems: updatedNestedItems
        }
      } as ReportSectionConfigurationWithOrder;
    }
    return section;
  });
}
